export default __webpack_public_path__ + "static/media/play_button.823566f5.svg";